import React from 'react';
import { MenuPopoverContent, Popover, PopoverTrigger } from '../../../../../../../components/Common/UI/Popover';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../../../components/Common/UI/Button';
import { INotifyModal } from '../index';

interface INotificationsSettings {
  handleOpen: ({ open, type }: INotifyModal) => void;
  editOnly?: boolean;
}

function NotificationsSettings({ handleOpen, editOnly }: INotificationsSettings) {
  return (
    <Popover>
      <PopoverTrigger>
        <Icons.Settings />
      </PopoverTrigger>
      <MenuPopoverContent className="mt-[5px] min-w-[100px]" align="start" wrapperClassName="hover:child:bg-white">
        <Button
          className="flex gap-[5px] font-[14px] w-full items-center h-auto !px-[10px] !py-[5px] bg-white"
          variant="ghost"
          onClick={() => handleOpen({ open: true, type: 'edit' })}
        >
          <Icons.EditNew className="w-[13px] h-[13px]" />
          Edit
        </Button>
        {!editOnly ? (
          <Button
            className="flex gap-[5px] font-[14px] w-full items-center h-auto !px-[10px] !py-[5px] bg-white"
            variant="ghost"
            onClick={() => handleOpen({ open: true, type: 'history' })}
          >
            <Icons.JobStatus className="w-[13px] h-[13px]" />
            History
          </Button>
        ) : null}
      </MenuPopoverContent>
    </Popover>
  );
}

NotificationsSettings.defaultProps = {
  editOnly: false,
};

export default NotificationsSettings;
